export type SettingsAreaId = 'personal' | 'school' | 'system'

export type SettingsTabId =
  | 'organization'
  | 'personal'
  | 'appearance'
  | 'security'
  | 'email-signature'
  | 'users'
  | 'noten'
  | 'system-admin'
  | 'geldkonten'
  | 'maintenance'
  | 'navigation-permissions'

export interface SettingsAreaDefinition {
  id: SettingsAreaId
  label: string
}

export interface SettingsTabDefinition {
  id: SettingsTabId
  label: string
  area: SettingsAreaId
  visible: boolean
}

export const SETTINGS_AREAS: SettingsAreaDefinition[] = [
  { id: 'personal', label: 'Persoenlich & Konto' },
  { id: 'school', label: 'Schule & Organisation' },
  { id: 'system', label: 'System & Administration' }
]

export function getDefaultTabForArea(area: SettingsAreaId, tabs: SettingsTabDefinition[]): SettingsTabId | null {
  const first = tabs.find((tab) => tab.area === area && tab.visible)
  return first?.id ?? null
}

export function isSettingsTabId(value: string): value is SettingsTabId {
  return [
    'organization',
    'personal',
    'appearance',
    'security',
    'email-signature',
    'users',
    'noten',
    'system-admin',
    'geldkonten',
    'maintenance',
    'navigation-permissions'
  ].includes(value)
}
